// extracted by mini-css-extract-plugin
export var ImageContainer = "Image-module--ImageContainer--ab1cd";
export var borderBottom = "Image-module--borderBottom--c96e1";
export var borderRight = "Image-module--borderRight--73aa1";
export var borderTop = "Image-module--borderTop--2cc63";
export var fitMobile = "Image-module--fitMobile--199cb";
export var hasCut = "Image-module--hasCut--ff6a6";
export var mdImage = "Image-module--mdImage--61347";